<div class="logo-upload-resize-component">

  @if (!showCropper) {
    <div class="form-group">
      <label for="tenant-settings-brand-logo" class="form-control-label" i18n="@@components.logo_upload_resize.label_logo">Logo</label><br>
      <div class="file-drop-area"
        [ngClass]="fileIsOver ? 'file-drop-area--file-over' : ''"
        (drop)="onDrop($event)"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        >
        <div class="file-drop-area__icon">
          <fa-icon [icon]="['fas', 'arrow-from-bottom']"></fa-icon>
        </div>
        <div class="file-drop-area__hint-text mt-1">
          <h3 class="mb-0" i18n="@@components.logo_upload_resize.upload_logo">Upload Logo</h3>
        </div>
        <input id="tenant-settings-brand-logo"
          type="file"
          class="mt-2"
          autocomplete="off"
          [accept]="allowedMimeTypes.join(',')"
          (change)="fileChangeEvent($event)"
          >
      </div>
    </div>
  } @else {
    <div class="image-cropper">
      <div class="icon-bar">
        <fa-icon [icon]="['fas', 'times']" [fixedWidth]="true" (click)="cancelCropping()" i18n-tooltip="@@common.cancel" tooltip="Cancel" container="body" placement="top"></fa-icon>
        <fa-icon [icon]="['fas', 'check']" [fixedWidth]="true" (click)="uploadImage()" i18n-tooltip="@@common.save" tooltip="Save" container="body" placement="top"></fa-icon>
      </div>
      <image-cropper
        style="max-height: 120px;"
        output="base64"
        alignImage="center"
        format="png"
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        [containWithinAspectRatio]="true"
        [aspectRatio]="120 / 50"
        [roundCropper]="false"
        [allowMoveImage]="false"
        [resizeToWidth]="120"
        [resizeToHeight]="50"
        [autoCrop]="true"
        [backgroundColor]="'transparent'"
        (imageCropped)="imageCropped($event)"
        (loadImageFailed)="loadImageFailed()"
      ></image-cropper>
    </div>
  }

</div>
